import {Bounce, toast} from "react-toastify";
import style from "../custom-components/errorToast/ErrorToast.module.scss";
import {CustomErrorToast} from "../custom-components/errorToast/ErrorToast.tsx";

export const showCustomErrorToast = (
    message: string,
    containerId: "login_id" | "main" | "publication_details_id" | "launch_modal",
    position: 'top-right' | 'top-center' | 'top-left' | 'bottom-right' | 'bottom-center' | 'bottom-left',
) => {
    toast(({closeToast}) => (
        <CustomErrorToast message={message} closeToast={closeToast}/>
    ), {
        containerId,
        autoClose: 1500,
        pauseOnHover: false,
        closeOnClick: false,
        position: position,
        hideProgressBar: true,
        transition: Bounce,
        closeButton: false,
        style: {animationDuration: "1s"},
        className: style.ToastContainerLogin,
    });
};
